// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { createVendor, deleteVendor, editVendor, getDetailVendor, getListVendors } from '~/thunks/vendors/vendorsThunk';
import { IDetailVendor } from '~/utils/interface/vendors';

export interface IVendorState {
  isRefreshList: boolean;
  isRefreshDetail: boolean;
  isLoading: boolean;
  detailVendor: IDetailVendor;
}

export const initialState: IVendorState = {
  isRefreshList: false,
  isRefreshDetail: false,
  isLoading: false,
  detailVendor: {} as IDetailVendor,
};

const vendorSlice = createSlice({
  name: 'vendors',
  initialState,
  reducers: {
    setIsRefreshList(state, action) {
      state.isRefreshList = action.payload;
    },
    setIsRefreshDetail(state, action) {
      state.isRefreshDetail = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: GET LIST VENDORS
    builder
      .addCase(getListVendors.pending, (_state) => {
        _state.isRefreshList = false;
      })
      .addCase(getListVendors.fulfilled, (_state) => {
        _state.isRefreshList = false;
      })
      .addCase(getListVendors.rejected, (_state) => {
        _state.isRefreshList = false;
      });

    // POST: CREATE VENDOR
    builder
      .addCase(createVendor.pending, (_state) => {})
      .addCase(createVendor.fulfilled, (_state) => {
        _state.isRefreshList = true;
      })
      .addCase(createVendor.rejected, (_state) => {});

    // PUT: EDIT VENDOR
    builder
      .addCase(editVendor.pending, (_state) => {})
      .addCase(editVendor.fulfilled, (_state) => {
        _state.isRefreshList = true;
      })
      .addCase(editVendor.rejected, (_state) => {});

    // GET: GET DETAIL VENDOR
    builder
      .addCase(getDetailVendor.pending, (_state) => {
        _state.isLoading = true;
      })
      .addCase(getDetailVendor.fulfilled, (_state, action) => {
        _state.detailVendor = action.payload.data;
        _state.isLoading = false;
      })
      .addCase(getDetailVendor.rejected, (_state) => {
        _state.isLoading = false;
      });

    // DELETE: DELETE VENDOR
    builder
      .addCase(deleteVendor.pending, (_state) => {})
      .addCase(deleteVendor.fulfilled, (_state) => {
        _state.isRefreshList = true;
      })
      .addCase(deleteVendor.rejected, (_state) => {});
  },
});

// Action
export const vendorActions = vendorSlice.actions;

// Reducer
const vendorReducer = vendorSlice.reducer;
export default vendorReducer;
